/**
 * Mescla o filtro base (prop do provider — ex.: categorias de uma página customizada)
 * com filtros dinâmicos já aplicados pelo usuário (busca, categoria avançada).
 *
 * O filtro base sobrescreve apenas suas próprias chaves; busca textual e demais
 * predicados do usuário permanecem intactos.
 */
export function mergeResourceRecordsFilter<T extends Record<string, unknown>>(
  currentFilter: T,
  baseFilter: Record<string, unknown>
): T {
  return { ...currentFilter, ...baseFilter } as T
}
